import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import TypeSelect from "./components/TypeSelect";
import { WO_TYPE_LIST } from "src/Common/contants";
import CustomerDropDown from "src/Pages/WO/Components/dropdown/customerdropdown";
import CustomerService from "src/Services/API/customer.service";
import WOStatusDropDown from "src/Pages/WO/Components/dropdown/wostatusdropdown";
import ApplyButton from "./components/ApplyButton";
import ClearButton from "./components/Clearbutton";
import UserService from "src/Services/API/user.service";
import TechDropDown from "./components/TechDropdown";
import { formatDate, getImageUrl } from "src/Common/common";
import DatePickerModal from "src/Common/datepickermodal";
import { handleError } from "src/Common/function";
import QuotedByDropdown from "src/Pages/WO/Components/dropdown/QuotedByDropdown";
import ServiceTypeDropdown from "src/Pages/WO/Components/dropdown/ServiceTypeDropdown";

const WOFitlerView = ({ apply, clear }) => {
  const currentUser = UserService.getCurrentUser();
  // const [type, setType] = useState(-1);
  const [serviceType, setServiceType] = useState(null);
  const [customer, setCustomer] = useState(-1);
  const [customerName, setCustomerName] = useState("");
  const [status, setStatus] = useState(-1);
  const [tech, setTech] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [quotedByUser, setQuotedByUser] = useState(null);

  //for fitlerview
  const [customers, setCustomers] = useState([]);
  const [customerNames, setCustomerNames] = useState([]);
  const [customerKeyword, setCustomerKeyword] = useState("");
  const [techArray, setTechArray] = useState([]);
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [isStartDate, setIsStartDate] = useState(true);
  const [quotedByUsers, setQuotedByUsers] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const criteria = searchParams.get("criteria");
  const branch = searchParams.get("branch");

  useEffect(() => {
    // if (localStorage.getItem("WO_CRITERIA") && customers.length > 0 && techArray.length > 0) {
    //   let saveCriteria = JSON.parse(localStorage.getItem("WO_CRITERIA"));

    //   setStatus(saveCriteria.status);
    //   setType(saveCriteria.type);
    //   setCustomer(saveCriteria.customer);
    //   setCustomerName(
    //     customers.find((item) => item.id === saveCriteria.customer)
    //       ? customers.find((item) => item.id === saveCriteria.customer).company
    //       : ""
    //   );
    //   setTech(
    //     techArray.find((item) => item.id === saveCriteria.tech)
    //       ? techArray.find((item) => item.id === saveCriteria.tech)
    //       : null
    //   );
    //   setStartDate(saveCriteria.startDate);
    //   setEndDate(saveCriteria.endDate);
    // }

    if (criteria) {
      let saveCriteria = JSON.parse(criteria);

      setStatus(saveCriteria.status);
      setServiceType(saveCriteria.serviceType);
      setCustomer(saveCriteria.customer);
      setCustomerName(
        customers.find((item) => item.id === saveCriteria.customer)
          ? customers.find((item) => item.id === saveCriteria.customer).companyName
          : ""
      );
      setTech(
        techArray.find((item) => item.id === saveCriteria.tech)
          ? techArray.find((item) => item.id === saveCriteria.tech)
          : null
      );
      setStartDate(saveCriteria.startDate);
      setEndDate(saveCriteria.endDate);
    }
  }, [techArray, customers]);

  useEffect(() => {
    CustomerService.getAll(customerKeyword)
      .then((response) => {
        if (response.status == 200) {
          setCustomers(response.data);
          setCustomerNames(response.data.map((item) => item.companyName));
        }
      })
      .catch((error) => {
        console.log("customer fetching error: ", error);
      });

    UserService.getUsersByRoleWithBranchId("Technician", branch)
      .then((response) => {
        if (response.status == 200) {
          let techs = response.data.filter((user) => user.isEnabled === true);
          UserService.getUsersByRoleWithBranchId("Manager", branch)
            .then((res) => {
              if (res.status == 200) {
                let managers = res.data.filter((user) => user.isEnabled === true);
                setTechArray([...techs, ...managers].sort((a, b) => a.name.localeCompare(b.name)));
              }
            })
            .catch((error) => handleError(error));
        }
      })
      .catch((error) => handleError(error));

    getQuotedByUsers();
  }, [branch, customerKeyword]);

  const getQuotedByUsers = async () => {
    try {
      const response1 = await UserService.getUsersByRoleWithBranchId("Administrator");
      const response2 = await UserService.getUsersByRoleWithBranchId("Manager");
      setQuotedByUsers(
        [
          ...response1.data.filter((user) => user.isEnabled === true),
          ...response2.data.filter((user) => user.isEnabled === true),
        ].sort((a, b) => a.name.localeCompare(b.name))
      );
    } catch (error) {
      console.log("quoted by users fetching error: ", error);
    }
  };

  const quotedByUserSelected = (index) => {
    setQuotedByUser(quotedByUsers[index]);
  };

  const customerSelected = (index) => {
    setCustomer(customers[index].id);
    setCustomerName(customers[index].companyName);
  };

  const applyFilter = () => {
    apply({
      serviceType: serviceType ? serviceType.id : -1,
      customer,
      status,
      tech: tech ? tech.id : -1,
      startDate,
      endDate,
      quotedBy: quotedByUser ? quotedByUser.id : -1,
    });
  };

  const clearFilter = () => {
    setServiceType(null);
    setCustomer(-1);
    setCustomerName("");
    setStatus(-1);
    setTech(null);
    setStartDate(null);
    setEndDate(null);
    setQuotedByUser(null);
    apply({
      serviceType: -1,
      customer: -1,
      status: -1,
      tech: null,
      startDate: null,
      endDate: null,
      quotedBy: -1,
    });

    clear();

    let url = removeQueryParam("criteria");
    navigate(url);
  };

  const techSelected = (index) => {
    setTech(techArray[index]);
  };

  const removeQueryParam = (queryToRemove) => {
    const currentPath = location.pathname;
    const currentSearch = location.search;

    const url = new URLSearchParams(currentSearch);
    if (queryToRemove) {
      url.delete(queryToRemove);
    }

    return `${currentPath}?${url.toString()}`;
  };

  return (
    <div className="w-full flex flex-wrap gap-3 py-5 relative z-20 pr-[120px]">
      <div className="absolute top-5 right-5 flex flex-col gap-2">
        <ApplyButton onClicked={applyFilter} />
        <ClearButton onClicked={clearFilter} />
      </div>
      <div className="w-[200px] flex flex-col gap-2 ">
        <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">by Service Type: </p>
        {/* <TypeSelect option={type >= 0 ? WO_TYPE_LIST[type] : "Select"} list={WO_TYPE_LIST[type]} onSelect={setType} /> */}
        <ServiceTypeDropdown selectedItem={serviceType} onSelect={setServiceType} />
      </div>
      <div className="w-[200px] flex flex-col gap-2 ">
        <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">by Customer: </p>
        <CustomerDropDown
          options={customerNames}
          defaultOption={customer >= 0 ? customerName : "Select"}
          onSelect={customerSelected}
          keywordChanged={setCustomerKeyword}
        />
      </div>
      <div className="w-[200px] flex flex-col gap-2 ">
        <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">by Status: </p>
        <WOStatusDropDown defaultOption={status} onSelect={(value) => setStatus(value)} />
      </div>
      <div className="w-[200px] flex flex-col gap-2 ">
        <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">by Technician: </p>
        <TechDropDown options={techArray} selectedTech={tech} onSelect={techSelected} />
      </div>

      <div className="w-[200px] flex flex-col gap-2 ">
        <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">Start date: </p>
        <div
          onClick={() => {
            setDatePickerOpen(true);
            setIsStartDate(true);
          }}
          className="w-full h-[30px] border-borderColor border-[1px] rounded-[6px] flex items-center px-1 gap-1"
        >
          <img src={getImageUrl("/images/wo/date.png")} />
          {startDate ? (
            <p className="text-[12px] font-OpenSansMedium font-[400] text-titleColor">
              {formatDate(startDate, "MM/DD/YYYY")}
            </p>
          ) : (
            <p className="text-[12px] font-OpenSansMedium font-[400] text-inputFieldTextColor">Start Date</p>
          )}
        </div>
      </div>

      <div className="w-[200px] flex flex-col gap-2 ">
        <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">End date: </p>
        <div
          onClick={() => {
            setDatePickerOpen(true);
            setIsStartDate(false);
          }}
          className="w-full h-[30px] border-borderColor border-[1px] rounded-[6px] flex items-center px-1 gap-1"
        >
          <img src={getImageUrl("/images/wo/date.png")} />
          {endDate ? (
            <p className="text-[12px] font-OpenSansMedium font-[400] text-titleColor">
              {formatDate(endDate, "MM/DD/YYYY")}
            </p>
          ) : (
            <p className="text-[12px] font-OpenSansMedium font-[400] text-inputFieldTextColor">End Date</p>
          )}
        </div>
      </div>
      <div className="w-[200px] flex flex-col gap-2 ">
        <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">Quoted by: </p>
        <QuotedByDropdown options={quotedByUsers} defaultOption={quotedByUser} onSelect={quotedByUserSelected} />
      </div>

      {datePickerOpen && (
        <DatePickerModal
          shown={datePickerOpen}
          pSelectedDate={isStartDate ? startDate : endDate}
          cancelClicked={() => setDatePickerOpen(false)}
          dateSelected={(date) => {
            if (isStartDate) {
              setStartDate(date);
            } else {
              setEndDate(date);
            }
            setDatePickerOpen(false);
          }}
          timeVisible={false}
        />
      )}
    </div>
  );
};

export default WOFitlerView;
